/* eslint-disable @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-explicit-any -- Disable all rules issued from linter */
import { type ClipboardInputTransformationData } from '@ckeditor/ckeditor5-clipboard';
import type RichTextEditorBase from 'rich-text-editor/build';

export type ClipboardImageValidatorErrorTranslationKey = 'sourceValidationFailed';

const findRecursiveWrongImage = (parent: any) => {
  if (parent.getChildren) {
    for (const element of parent.getChildren()) {
      if (element.name === 'img' && parent.name !== 'figure') {
        return true;
      }

      if (findRecursiveWrongImage(element)) {
        return true;
      }
    }
  }

  return false;
};

const clipboardImageValidator = (onError: (key: ClipboardImageValidatorErrorTranslationKey) => void) => {
  return function (editor: RichTextEditorBase) {
    editor.plugins
      .get('ClipboardPipeline')
      .on('inputTransformation', (event_, data: ClipboardInputTransformationData) => {
        const { content } = data;

        if (findRecursiveWrongImage(content)) {
          event_.stop();
          onError('sourceValidationFailed');
        }
      });
  };
};

export default clipboardImageValidator;
/* eslint-enable @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-explicit-any -- Disable all rules issued from linter */
